import { serverSideTranslations } from '@holo/i18n/serverSideTranslations';
import type { GetStaticProps } from 'next';
import SEO from '@holo/seo';
import SaleHero from '@/components/SaleHero/SaleHero';
import StoreSection from '@/components/StoreSection/StoreSection';
import DashboardSection from '@/components/DashboardSection/DashboardSection';
import CropPlanningSection from '@/components/CropPlanningSection/CropPlanningSection';
import OrderPackingSection from '@/components/OrderPackingSection/OrderPackingSection';
import HarvestingSection from '@/components/HarvestingSection/HarvestingSection';
import AboutHoloBanner from '@/components/AboutHoloBanner/AboutHoloBanner';
import CarbonPositiveBanner from '@/components/CarbonPositiveBanner/CarbonPositiveBanner';

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: await serverSideTranslations(locale),
  };
};

const Platform = () => {
  return (
    <>
      <SEO title="FarmOS" />
      <SaleHero />
      <StoreSection />
      <DashboardSection />
      <CropPlanningSection />
      <HarvestingSection />
      <OrderPackingSection />
      <CarbonPositiveBanner />
      <AboutHoloBanner />
    </>
  );
};

export default Platform;
